import { apiFetcher } from '../../../fetcher';
import { BASE_MAPPING_URL } from '../constants';

const mapGame = ({ slug, slugStore }) => apiFetcher(`${BASE_MAPPING_URL}${slug}/${slugStore}/`, {
    method: 'POST',
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
});

const unmapGame = ({ slug, slugStore, queryClient }) => apiFetcher(`${BASE_MAPPING_URL}${slug}/${slugStore}/`, {
    method: 'DELETE',
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
}).then(() => {
    if (queryClient) {
        queryClient.invalidateQueries([`${BASE_MAPPING_URL}${slug}/`]);
    }
});

export { mapGame, unmapGame };
